import {Component, inject, Input} from '@angular/core';
import {AsyncPipe, DatePipe} from "@angular/common";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {Observable} from "rxjs";
import {ColDef, GridApi, GridReadyEvent, SizeColumnsToFitGridStrategy} from "ag-grid-community";
import {FormatBoolean} from "../../cell-renderers/show-played/format-boolean.component";
import {AgGridAngular} from "ag-grid-angular";
import {TestimonialsService} from "../../../services/testimonials.service";
import {IGameTestimonials} from "../../../interfaces/IGameTestimonials";
import {TestimonialsSettingsComponent} from "../testimonial-settings/testimonials-settings.component";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";

@Component({
  selector: 'app-testimonials-table',
  standalone: true,
  imports: [
    AgGridAngular,
    AsyncPipe
  ],
  templateUrl: './testimonials-table.component.html',
  styleUrl: './testimonials-table.component.scss'
})
export class TestimonialsTableComponent {

  @Input() set gameSetter(gameP: IGameQueryResult) {
    this.fetchTestimonials(gameP);
  }

  private datePipe: DatePipe = inject(DatePipe);
  private testimonialsService: TestimonialsService = inject(TestimonialsService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);
  public defaultColDef: ColDef = {
    flex: 1,
    cellDataType: false,
  };
  public themeClass: string =
    "ag-theme-quartz";
  public uiState = UIStateEnum.ShowLoading;
  public uiStateForTemplate = UIStateEnum;
  public testimonialsForGame$: Observable<IGameTestimonials[]> = this.testimonialsService.selectGameTestimonials$();
  public testimonialsGridApi!: GridApi<IGameTestimonials>;
  public autoSizeStrategy: SizeColumnsToFitGridStrategy = {
    type: 'fitGridWidth'
  };

  public testimonialsDefs: ColDef[] = [
    {
      headerName: 'Id',
      flex: 1,
      field: 'Id',
    },
    {
      headerName: 'Name of User',
      field: 'GivenByUserName',
    },
    {
      headerName: 'Position of User',
      field: 'GivenByUserPosition'
    },
    {
      headerName: 'Testimonial',
      field: 'Content',
      cellRenderer: (params: any) => {
        return `<div title="${params.value}">${params.value.substring(0, 50)}${params.value.length > 50 ? '...' : ''}</div>`;
      }
    },
    {
      headerName: 'Created On Date',
      maxWidth: 140,
      valueFormatter: params => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y');
        return convertedDate ? convertedDate : '';
      },
      field: 'CreatedOn'
    },
    {
      headerName: 'Active',
      maxWidth: 80,
      cellRenderer: FormatBoolean,
      field: 'Active',
    },
    {
      maxWidth: 80,
      cellRenderer: TestimonialsSettingsComponent
    }
  ];

  fetchTestimonials(gameP: IGameQueryResult): void {
    this.testimonialsService.fetchTestimonials(gameP.Id).subscribe({
      next: () => {
        this.uiState = UIStateEnum.ShowData;
      }, error: (error) => {
        this.errorHandlingService.displayPageLevelErrorMessage(error);
        this.uiState = UIStateEnum.ShowData;
      }
    })
  }

  onTestimonialGridReady(params: GridReadyEvent<IGameTestimonials>) {
    this.testimonialsGridApi = params.api;
    this.testimonialsGridApi.sizeColumnsToFit({
      defaultMinWidth: 90,
    });
  }
}
